type Listener = (authenticated: boolean) => void;

let currentStatus: boolean = false;
let polling = false;
const listeners = new Set<Listener>();

async function fetchAdminCheck(): Promise<boolean> {
  try {
    const res = await fetch("/api/admin/check", { credentials: "include" });
    if (res.ok) {
      const data = await res.json();
      return !!data.authenticated;
    }
  } catch {}
  return false;
}

function notify(status: boolean) {
  currentStatus = status;
  listeners.forEach(fn => fn(status));
}

let intervalId: ReturnType<typeof setInterval> | null = null;

const IDLE_POLL_INTERVAL = 30000;

async function poll() {
  if (listeners.size === 0) {
    stopPolling();
    return;
  }
  if (typeof document !== "undefined" && document.hidden) return;
  const status = await fetchAdminCheck();
  notify(status);
}

function stopPolling() {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  polling = false;
}

function ensurePolling() {
  if (polling) return;
  if (typeof document !== "undefined" && document.hidden) return;
  polling = true;
  poll();
  intervalId = setInterval(poll, IDLE_POLL_INTERVAL);
}

function handleVisibilityChange() {
  if (document.hidden) {
    stopPolling();
  } else if (listeners.size > 0) {
    ensurePolling();
  }
}

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", handleVisibilityChange);
}

export function getAdminStatus(): boolean {
  return currentStatus;
}

export function subscribeAdminStatus(fn: Listener): () => void {
  listeners.add(fn);
  ensurePolling();
  fn(currentStatus);
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      stopPolling();
    }
  };
}

export async function refreshAdminStatus(): Promise<boolean> {
  const status = await fetchAdminCheck();
  notify(status);
  return status;
}
